import Vue from "vue";
import VueRouter from "vue-router";
import Calculo from "../views/Calculo.vue";
import Posicion from "../views/Posicion.vue";
import Tracking from "../views/Tracking.vue";
import Login from '../views/Login';
import Logout from '../views/Logout';
import Documents from '../views/Documents'

import store from "../store";

Vue.use(VueRouter);
export const Routes = {
  CALCULO: "Cálculo",
  POSICION: "Posición",
  TRACKING: "Tracking",
  DOCUMENTOS: "Documentos"
};


const routes = [
  {
    path: "/",
    name: Routes.CALCULO,
    component: Calculo,
    meta: {
      auth: true
    }
  },
  {
    path: "/posicion",
    name: Routes.POSICION,
    component: Posicion,
    meta: {
      auth: true
    }
  },
  {
    path: "/tracking",
    name: Routes.TRACKING,
    component: Tracking,
    meta: {
      auth: true
    }
  },
  {
    path: "/documents",
    name: Routes.DOCUMENTOS,
    component: Documents,
    meta: {
      auth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Sarexpress";
  if (to.query.from) {
    next({ query: to.query });
  } else if (
    (store.state.user && localStorage.getItem("token")) ||
    !to.meta.auth
  ) {
    next();
  } else if (to.meta.auth && !window.localStorage.getItem("token")) {
    next({ path: "/login" });
    // } else if (to.meta.auth && window.localStorage.getItem("token")) {
    //   next({ path: "/posicion", query: { from: to.fullPath } });
    //   console.log('Ver si aca no hay que agregar tracking');
    // } else if (to.meta.auth && window.localStorage.getItem("token")) {
    //   next({ path: "/tracking", query: { from: to.fullPath } });
  } else {
    next();
  }
});

export default router;
